import ConvokeObjectManager from './ConvokeObjectManager'
import { ItemServiceFactory } from '../../services/ItemServiceFactory';

class ConvokeWarehouseViewManager extends ConvokeObjectManager {
    constructor(id, coreContext, coreState, operationName, isWarning) {
        const factory = new ItemServiceFactory();
        super(
            id,
            coreContext,
            coreState,
            factory.ItemServiceEnum.WarehouseView,
            factory.ItemServiceEnum.WarehouseViewQuery,
            operationName,
            isWarning
        );
    }
}

export default ConvokeWarehouseViewManager;
